import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vShow as _vShow, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "gfu-field__toggle gfu-field-toggle" }
const _hoisted_2 = ["name", "value", "disabled", ".indeterminate"]
const _hoisted_3 = { class: "gfu-field-toggle__label-text" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_field = _resolveComponent("field")

  return (_openBlock(), _createBlock(_component_field, _mergeProps({..._ctx.$attrs, ..._ctx.$props}, {
    "display-name": $props.condensed ? ' ' : $props.displayName,
    "read-only": $props.readOnly,
    disabled: $props.disabled,
    "show-label": !$props.condensed
  }), {
    default: _withCtx(() => [
      _createElementVNode("label", _hoisted_1, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.model) = $event)),
          class: "gfu-field-toggle__input",
          type: "checkbox",
          name: _ctx.name,
          value: $props.checkedValue,
          disabled: $props.readOnly || $props.disabled,
          ".indeterminate": $options.isIndeterminate,
          "data-qa": "checkbox-input"
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2), [
          [_vModelCheckbox, _ctx.model]
        ]),
        _createElementVNode("span", {
          class: _normalizeClass(["gfu-field-toggle__label", {'gfu-field-toggle__label--disabled': $props.disabled, 'gfu-field-toggle__label--read-only': $props.readOnly}]),
          onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.toggleState && $options.toggleState(...args)), ["prevent"]))
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(["gfu-field-toggle__icon", {'gfu-field-toggle__icon--indeterminate': $options.isIndeterminate}]),
            "data-qa": "checkbox-field-icon"
          }, null, 2 /* CLASS */),
          _createElementVNode("span", _hoisted_3, [
            _withDirectives(_createElementVNode("em", null, "*", 512 /* NEED_PATCH */), [
              [_vShow, _ctx.isRequired]
            ]),
            _cache[2] || (_cache[2] = _createTextVNode()),
            _createElementVNode("span", null, [
              _createElementVNode("span", null, _toDisplayString($props.condensed ? $props.displayName : ''), 1 /* TEXT */)
            ])
          ])
        ], 2 /* CLASS */)
      ])
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */, ["display-name", "read-only", "disabled", "show-label"]))
}